import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n'
import messages from './locales'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const i18n = createI18n({
    legacy: false,
    locale: 'zh',
    fallbackLocale: 'en',
    messages,
})

const app = createApp(App)
app.use(i18n)
app.use(ElementPlus)
app.use(store)
app.use(router)
app.mount('#app')
